export default {"src":"/_next/static/media/visualorcwhite.5fca6034.svg","height":94,"width":488,"blurWidth":0,"blurHeight":0};